import { render, staticRenderFns } from "./index.page.vue?vue&type=template&id=230be80f&scoped=true&"
import script from "./index.page.vue?vue&type=script&lang=js&"
export * from "./index.page.vue?vue&type=script&lang=js&"
import style0 from "./index.page.vue?vue&type=style&index=0&id=230be80f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "230be80f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('230be80f')) {
      api.createRecord('230be80f', component.options)
    } else {
      api.reload('230be80f', component.options)
    }
    module.hot.accept("./index.page.vue?vue&type=template&id=230be80f&scoped=true&", function () {
      api.rerender('230be80f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/statistics/commodity/index.page.vue"
export default component.exports